import { Box, CircularProgress } from "@mui/material";
import { postGoogleOauthCode } from "api/api";
import { useEffect } from "react";

import { useNavigate } from "react-router-dom";
import { useAuthState } from "store/store";

export const GoogleOauthRedirect = () => {
  const navigate = useNavigate();

  const { setToken } = useAuthState();

  const handleGoogleOauthRedirect = async () => {
    const search = new URLSearchParams(window.location.search);
    const code = search.get("code");
    if (!code) return navigate("/");
    const response = await postGoogleOauthCode({ code });

    const accessToken = response.data.accessToken; // string
    setToken(accessToken);
    navigate("/");
  };

  useEffect(() => {
    handleGoogleOauthRedirect();
  }, []);

  return (
    <>
      <Box sx={{ textAlign: "center", mt: 6 }}>
        <CircularProgress />
      </Box>
    </>
  );
};

export default GoogleOauthRedirect;
